import React from 'react'

const Overline = (props) => <span><span className='overline'></span>{props.children}</span>

export default Overline


// WEBPACK FOOTER //
// ./src/components/_Overline.js